var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    fill: "#c1501f",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.495,348.369l29.676-29.677l61.53-61.529l29.676-29.676c29.905,8.297,63.297,0.696,86.809-22.815 c23.511-23.511,31.112-56.903,22.815-86.809l-45.974,45.974c-12.497,12.497-32.758,12.497-45.255,0l-16.617-16.617 c-12.497-12.497-12.497-32.758,0-45.255l45.974-45.973c-29.905-8.297-63.298-0.696-86.809,22.815 c-23.512,23.511-31.113,56.903-22.815,86.809l-29.676,29.676l-61.53,61.53l-29.676,29.676 c-29.905-8.298-63.297-0.696-86.809,22.815s-31.113,56.902-22.815,86.809l45.973-45.974c12.498-12.497,32.758-12.497,45.255,0 l16.617,16.617c12.497,12.497,12.497,32.758,0,45.255l-45.973,45.974c29.906,8.297,63.297,0.695,86.809-22.815 C227.191,411.666,234.793,378.274,226.495,348.369z M228.417,305.788c-5.857,5.857-15.355,5.857-21.213,0 c-5.858-5.857-5.858-15.355,0-21.213l77.781-77.782c5.858-5.858,15.355-5.858,21.214,0c5.857,5.858,5.857,15.355,0,21.213 L228.417,305.788z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTech);
export default __webpack_public_path__ + "static/media/tech.87917e8163a9457e74eb71aaa5e5f77e.svg";
export { ForwardRef as ReactComponent };